import CulturePriceList from './CulturePriceList';
import DateTimePicker from '@/components/DSE/DateTimePicker';
import MDinput from '@/components/MDinput';
import { validatorRequire } from '@/utils/validators';
import { toISOString } from '@/utils/date';
export function getFormDefinition(vue) {
  return {
    startDate: {
      type: DateTimePicker,
      props: {
        type: 'date',
        caption: 'common.startDate',
        format: 'dd-MM-yyyy',
        valueFormat: 'yyyy-MM-dd',
        required: true,
        parseToMilliSeconds: false,
        weekPickerOptions: {
          disabledDate(date) {
            const today = new Date();
            today.setDate(today.getDate() - 1);
            return new Date(date) < today;
          },
          firstDayOfWeek: 1
        }
      },
      rules: [{ validator: validatorRequire }]
    },
    widthInCm: {
      type: MDinput,
      props: {
        type: 'number',
        caption: 'priceListItem.width',
        disabled: true
      },
      dynamicProps: form => ({
        visible: form.widthInCm !== null
      })
    },
    heightInCm: {
      type: MDinput,
      props: {
        type: 'number',
        caption: 'priceListItem.height',
        disabled: true
      },
      dynamicProps: form => ({
        visible: form.heightInCm !== null
      })
    },
    laborPrice: {
      type: MDinput,
      defaultValue: 0,
      props: {
        type: 'currency',
        caption: 'priceListItemPrice.laborPrice',
        min: 0
      },
      dynamicProps: form => ({
        currencyPrefix: form.laborSymbol
      })
    },
    culturePrices: {
      type: CulturePriceList,
      props: {
        caption: 'priceListItemPrice.consumerPrices',
        min: 0,
        priceKey: 'cultureID'
      }
    },
    countryPrices: {
      type: CulturePriceList,
      props: {
        caption: 'priceListItemPrice.workshopPrices',
        min: 0,
        priceKey: 'countryID'
      }
    }
  };
}

export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  const item = {
    ...form,
    domainID: +this.$route.params.domainID,
    startDate: toISOString(form.startDate)
  };

  return item;
}

export function createFormDataFromItem(vue, item) {
  const form = {
    ...item
  };
  return form;
}
